import {RECEIVE_HEADER_MENU,
        RECEIVE_FOOTER_MENU,
        RECEIVE_FOOTER_SITEMAP,
        RECEIVE_HEADINGS_INFO,
        RECEIVE_NEWS_MAIN_PAGE,
        REQUEST_NEWS_MAIN_PAGE,
        SET_NEWS_MAIN_PAGE_ERROR,
        RECEIVE_POS_MAIN_PAGE,
        REQUEST_POS_MAIN_PAGE,
        SET_POS_MAIN_PAGE_ERROR,
        REQUEST_PBL_NUMBER,
        RECEIVE_PBL_NUMBER,
        SET_PBL_NUMBER_ERROR,
        REQUEST_WHAT_IN_PBL,
        RECEIVE_WHAT_IN_PBL,
        SET_WHAT_IN_PBL_ERROR} from '../constants/ActionTypes';

const initialState = {
    isFetchingNews: false,
    isNewsError: false,
    isFetchingPos: false,
    isFetchingWhatInPbl: false,
    isPosError: false,
    isFetchingPblNumber: false,
    isPblNumberError: false,
    isWhatInPblError: false,
    news: [],
    pblNumber: [],
    pos: {},
    whatInPbl: [],
};

export default function mainPage(state = initialState, action) {
    switch (action.type) {
        case RECEIVE_HEADER_MENU:
            return {
                ...state,
                menuData: action.data.items
            };
        case RECEIVE_FOOTER_MENU:
            return {
                ...state,
                footerData: action.data.acf
            };
        case RECEIVE_FOOTER_SITEMAP:
            return {
                ...state,
                footerSitemapData: action.data.items
            };
        case RECEIVE_HEADINGS_INFO:
            return {
                ...state,
                searchHeadingsInfo: action.data
            };
        case REQUEST_NEWS_MAIN_PAGE:
            return {
                ...state,
                isFetchingNews: true,
                isNewsError: false
            };
        case REQUEST_POS_MAIN_PAGE:
            return {
                ...state,
                isFetchingPos: true,
                isPosError: false
            };
        case REQUEST_PBL_NUMBER:
            return {
                ...state,
                isFetchingPblNumber: true,
                isPblNumberError: false
            };
        case REQUEST_WHAT_IN_PBL:
            return {
                ...state,
                isFetchingWhatInPbl: true,
                isWhatInPblError: false
            };
        case RECEIVE_NEWS_MAIN_PAGE:
            return {
                ...state,
                isFetchingNews: false,
                news: action.data.slice(0, 4)
            };
        case RECEIVE_POS_MAIN_PAGE:
            return {
                ...state,
                isFetchingPos: false,
                pos: action.data.acf
            };
        case RECEIVE_WHAT_IN_PBL:
            return {
                ...state,
                isFetchingWhatInPbl: false,
                whatInPbl: action.data
            };
        case RECEIVE_PBL_NUMBER:
            return {
                ...state,
                isFetchingPblNumber: false,
                pblNumber: action.data
            };
        case SET_NEWS_MAIN_PAGE_ERROR:
            return {
                ...state,
                isFetchingNews: false,
                isNewsError: true
            };
        case SET_POS_MAIN_PAGE_ERROR:
            return {
                ...state,
                isFetchingPos: false,
                isPosError: true
            };
        case SET_PBL_NUMBER_ERROR:
            return {
                ...state,
                isFetchingPblNumber: false,
                isPblNumberError: true
            };
        case SET_WHAT_IN_PBL_ERROR:
            return {
                ...state,
                isFetchingWhatInPbl: false,
                isWhatInPblError: true
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/mainPage.js